// import { createApp } from 'vue/dist/vue.esm-bundler.js';
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vClickOutside from "./directives/click-outside";
import { Calendar, DatePicker } from "v-calendar";
import { Money3Component } from "v-money3";
import VueChartkick from "vue-chartkick";
import "chartkick/chart.js";
import VueMultiselect from "@suadelabs/vue3-multiselect";
import vSelect from "vue-select";
import VueConfetti from "vue-confetti";
import { vMaska } from "maska/vue";
import VTooltip from "v-tooltip";

import "v-calendar/style.css";
import "vue-multiselect/dist/vue-multiselect.min.css";
import "vue-select/dist/vue-select.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

// PLUGINS
import filters from "./plugins/filters";
import countries from "./plugins/countries";
import ToastPlugin from "./plugins/toast";
import SocketPlugin from "./plugins/socket";
import ipAddress from "./plugins/ipAddress";

if (import.meta?.env?.PROD) {
    console.log = () => {};
    console.debug = () => {};
    console.info = () => {};
}

createApp(App)
    .directive("click-outside", vClickOutside)
    .directive("maska", vMaska)
    .use(SocketPlugin)
    .use(router)
    .use(store)
    .use(filters)
    .use(countries)
    .use(ToastPlugin)
    .use(VueChartkick)
    .use(VTooltip)
    .use(VueConfetti)
    // .use(setupCalendar, {})
    .component("vue-multi-select", VueMultiselect)
    .component("money", Money3Component)
    .component("v-select", vSelect)
    .component("v-calendar", Calendar)
    .component("v-date-picker", DatePicker)
    .mount("#app");

window.debounceId = undefined;